import React from "react";
import { Box, Typography } from "@mui/material";
import PropTypes from "prop-types";
// import AutoTradeStepper from "./AutoTradeStepper";
import AutoTradeStepper from "./MinerStepper";
import One from "./One";
import Two from "./Two";

export default function UDAutotradeUI({ pathname }) {
	return (
		<Box
			sx={{
				py: 4,
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				textAlign: "center",
			}}>
			<AutoTradeStepper />
			<One />
			<Two />
		</Box>
	);
}

UDAutotradeUI.propTypes = {
	pathname: PropTypes.string.isRequired,
};
